interface IYearlyKeyInitiativeSetting {
  fYear?: number
}

export const filterKeyInitiativeSettingsByYear = <T extends IYearlyKeyInitiativeSetting>(
  settings: readonly T[],
  fYear: number
): T[] => settings.filter((setting) => setting.fYear === fYear)
